// extracted by css-extract-rspack-plugin
export default {"IconButton":"NavigationMenu-module__IconButton__HpX3G","Button":"NavigationMenu-module__Button__LpKgm","ActionMenu_Overlay":"NavigationMenu-module__ActionMenu_Overlay__iaiOT"};